import { render, staticRenderFns } from "./SupportConfirm.vue?vue&type=template&id=75c049c5&scoped=true&"
import script from "./SupportConfirm.vue?vue&type=script&lang=ts&"
export * from "./SupportConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./SupportConfirm.vue?vue&type=style&index=0&id=75c049c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c049c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
